// extracted by mini-css-extract-plugin
module.exports = {"body":"EmptyRequest_body__NkkSH","emptyImage":"EmptyRequest_emptyImage__3Dm8Q"};